import * as types from 'constants/actionTypes';
import * as operationsApi from 'api/operationsApi';
import { beginAjaxCall, ajaxCallError } from './ajaxCallActions.js';

export function getContainerTypes() {
  return function(dispatch) {
    dispatch(beginAjaxCall());
    return operationsApi
      .getContainerTypes()
      .then(
        response => dispatch(getContainerTypesSuccess(response)),
        error => dispatch(ajaxCallError())
      );
  };
}

function getContainerTypesSuccess(response) {
  return {
    type: types.GET_CONTAINER_TYPES_SUCCESS,
    containerTypes: response.data || []
  };
}
